import { Transaction } from '../accounting/Transaction'
import { Order } from '../sales/Order'
import Insurance from "@/models/insurance/Insurance";

export default class InsuranceAccountStatement {
  static from(json: Record<string, unknown> | InsuranceAccountStatement) {
    const accountStatement = Object.assign(new InsuranceAccountStatement(), json)
    if (accountStatement.insurance)
      accountStatement.insurance = Insurance.from(accountStatement.insurance)
    if (accountStatement.orders)
      accountStatement.orders = accountStatement.orders.map((order) => Order.from(order))
    if (accountStatement.transactions)
      accountStatement.transactions = accountStatement.transactions.map((transaction) =>
        Transaction.from(transaction)
      )
    return accountStatement
  }
  static ENDPOINT = '/reports/insurance/account-statement'

  insurance?: Insurance
  orders: Array<Order> = []
  transactions: Array<Transaction> = []
  printedOn?: string
}
